import MediaLoader from '@components/MediaLoader';
import s from './Dashboard.module.scss';

const SectionShimmer: React.FC = () => (
  <MediaLoader message='' className={s['section-shimmer__loader']} />
);

export default SectionShimmer;